import { render, staticRenderFns } from "./common-list.vue?vue&type=template&id=593a745b&scoped=true"
import script from "./common-list.vue?vue&type=script&lang=js"
export * from "./common-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593a745b",
  null
  
)

export default component.exports